import { render, staticRenderFns } from "./ViewUnregistered.vue?vue&type=template&id=13a88f12&scoped=true"
import script from "./ViewUnregistered.vue?vue&type=script&lang=js"
export * from "./ViewUnregistered.vue?vue&type=script&lang=js"
import style0 from "./ViewUnregistered.vue?vue&type=style&index=0&id=13a88f12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a88f12",
  null
  
)

export default component.exports